var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSendMailIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 1.25H2.5C1.67157 1.25 1 1.92157 1 2.75V11.25C1 12.0784 1.67157 12.75 2.5 12.75H13.5C14.3284 12.75 15 12.0784 15 11.25V2.75C15 1.92157 14.3284 1.25 13.5 1.25Z",
    stroke: "#4D4AEA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_43_1441",
    maskUnits: "userSpaceOnUse",
    x: 0.5,
    y: 2,
    width: 15,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.5,
    y: 2,
    width: 15,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3L7.36 8C7.53969 8.14967 7.76615 8.23163 8 8.23163C8.23385 8.23163 8.46031 8.14967 8.64 8L14.5 3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.14908 2.23928C1.72894 1.8808 1.09776 1.93079 0.739279 2.35092C0.380803 2.77106 0.430786 3.40224 0.850921 3.76072L2.14908 2.23928ZM7.36 8L6.71088 8.76077L6.72 8.76837L7.36 8ZM8 8.23163V7.23163V8.23163ZM8.64 8L9.28005 8.76843L9.28908 8.76072L8.64 8ZM15.1491 3.76072C15.5692 3.40224 15.6192 2.77106 15.2607 2.35092C14.9022 1.93079 14.2711 1.8808 13.8509 2.23928L15.1491 3.76072ZM0.850921 3.76072L6.71092 8.76072L8.00908 7.23928L2.14908 2.23928L0.850921 3.76072ZM6.72 8.76837C7.07937 9.06771 7.53229 9.23163 8 9.23163V7.23163V7.23163L6.72 8.76837ZM8 9.23163C8.46771 9.23163 8.92063 9.06771 9.28 8.76837L8 7.23163V7.23163V9.23163ZM9.28908 8.76072L15.1491 3.76072L13.8509 2.23928L7.99092 7.23928L9.28908 8.76072Z",
    fill: "#4D4AEA",
    mask: "url(#path-2-outside-1_43_1441)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSendMailIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send_mail_icon.5b7a5225ec461568110ca92ba6bdf195.svg";